import React from 'react'
import { Row,Col } from 'antd';
import { FiYoutube, FiTwitter, FiFacebook, FiInstagram } from 'react-icons/fi';
import { TbWorld } from "react-icons/tb";
import { ImLocation2 } from 'react-icons/im';
import { FaPhoneAlt } from 'react-icons/fa';
import { IoMdMail } from 'react-icons/io';
import moment from 'moment';

const Footer = () => {
  return (
    <div className='h-full bg-theme-dark w-full p-2 md:p-4 bottom-0 left-0'>
        <div className='container mx-auto'>
        <Row gutter={[16,8]} justify={"space-between"}  className='text-white flex'>
            <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} className='text-md'>
                <h1 className='uppercase font-semibold pb-4'>Бидний эрхэм зорилго</h1>
                <p className='text-justify pr-8 border-0 md:border-r border-white h-auto sm:h-48'>Энэхүү платформыг Цаг уур, орчны шинжилгээний газрын архив мэдээллийн сангийн цаг уурын ажиглалтын мэдээллийг цахим хуудсаар дамжуулан хурдан шуурхай, хялбар байдлаар авах, төлбөр тооцоог интернэт сүлжээг ашиглан төлөх зэрэг үйлчилгээг үзүүлэх зорилготой хөгжүүлэв.</p>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} className='md:px-8 text-md'>
                <h1 className='uppercase font-semibold pb-4'>Харьяа байгууллагууд</h1>
                <div className='flex flex-col border-0 lg:border-r border-white pr-8 h-auto sm:h-48'>
                    <a href="https://www.namem.gov.mn/" target='_blank' className='text-justify'>Цаг уур, орчны шинжилгээний газар</a>
                    <a href='https://irimhe.namem.gov.mn/' target='_blank' className='text-justify mt-2'>Ус цаг уур, орчны судалгаа, мэдээллийн хүрээлэн</a>
                    <a href='https://amc.namem.gov.mn/' target='_blank' className='text-justify mt-2'>Нислэгийн цаг уурын төв</a>
                    <a href='https://clem.namem.gov.mn/' target='_blank' className='text-justify mt-2'>Байгаль орчин, хэмжилзүйн төв лаборатори</a>
                </div>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} className='md:pr-8 h-full text-md'>
                <h1 className='uppercase font-semibold pb-4'>Холбоо барих</h1>
                <div className='flex flex-col border-0 md:border-r border-white pr-8 h-auto sm:h-48'>
                    <a className='text-justify flex justify-start items-start'><span className='mt-1 mr-1'><ImLocation2/></span>Улаанбаатар-15160 Чингэлтэй дүүрэг, 4-р хороо, Жуулчны гудамж-5, Бага тойруу-3 Цаг уур, орчны шинжилгээний газар</a>
                    <a className='text-justify flex justify-start items-start mt-2'><span className='mt-1 mr-1'><FaPhoneAlt/></span>51-266149, 11-326609</a>
                    <a className='text-justify flex justify-start items-start mt-2'><span className='mt-1 mr-1'><IoMdMail/></span>info@namem.gov.mn</a>
                </div>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} className='md:pr-8 text-md'>
                <h1 className='uppercase font-semibold pb-4'>Цэснүүд</h1>
                <div className='flex flex-col'>
                    <a href='/login' className='md:w-72 text-justify'>Нэвтрэх</a>
                    <a target='_blank' href='https://weather.gov.mn/' className='md:w-72 text-justify mt-2'>Цаг агаарын мэдээ, мэдээлэл</a>
                </div>
            </Col>
            <Col span={24}>
                <div className='flex items-center justify-center text-2xl mt-8'>
                    <div className='w-full border-b border-slate-200'></div>
                    <a href='https://www.facebook.com/Mongolianweather' target='_blank' className='cursor-pointer hover:text-sky-900 hover:bg-sky-200 duration-500 rounded-full bg-white py-2 px-2 text-sky-700 mx-2 ml-4'><FiFacebook/></a> 
                    <a href='https://www.gov.mn/mn/organization/namem' target='_blank' className='cursor-pointer hover:text-sky-900 hover:bg-sky-200 duration-500 rounded-full bg-white py-2 px-2 text-sky-700 mx-2'><TbWorld/></a> 
                    <a href='https://www.youtube.com/@weathertvmongolia2107' target='_blank' className='cursor-pointer hover:text-sky-900 hover:bg-sky-200 duration-500 rounded-full bg-white py-2 px-2 text-sky-700 mx-2'><FiYoutube/></a>
                    <a href='https://x.com/Namemweather' target='_blank' className='cursor-pointer hover:text-sky-900 hover:bg-sky-200 duration-500 rounded-full bg-white py-2 px-2 text-sky-700 mx-2 mr-4'><FiTwitter/></a> 
                    <a className='w-full border-b border-slate-200'></a>
                </div>
            </Col>
            <Col span={24}>
                <div className='text-center'>
                    <div className='w-full text-white uppercase mt-4 text-md'>{`© ЦАГ УУР, ОРЧНЫ ШИНЖИЛГЭЭНИЙ ГАЗАР ${moment().format("YYYY")} ОН`}</div>
                </div>
            </Col>
        </Row>
        </div>

      
    </div>
  )
}

export default Footer
